import React from 'react';
import { connect } from 'react-redux';
import HeaderBrand from './HeaderBrand';
import { LOGIN } from '../store/Types/Logintypes';
import './LayoutWrapper.css';

/**
 * LayoutWrapper
 *
 * Responsibility: pick which nav to show based on viewport.
 *
 *  ≥ 992px  →  The original Header.js sidebar is rendered by the
 *              parent app (not here). LayoutWrapper adds the desktop
 *              page content offset so content sits next to the sidebar.
 *
 *  < 992px  →  HeaderBrand (top bar + bottom footer + more-menu grid)
 *              is mounted here. Content gets top/bottom padding to
 *              clear both fixed bars.
 */

const LayoutWrapper = ({ children, userRoleAccountData, accesstoken }) => {
  return (
    <>
      {/* Shown only on mobile/tablet via CSS (display:none on desktop) */}
      <div className="layout-mobile-header">
        <HeaderBrand
          userRoleAccountData={userRoleAccountData}
          accesstoken={accesstoken}
        />
      </div>

      {/* Page content */}
      <main className="layout-main">
        <div className="layout-content">
          {children}
        </div>
      </main>
    </>
  );
};

const mapStateToProps = (store) => ({
  userRoleAccountData: store.loginreducers.userRoleAccountData,
  access_token: store.loginreducers.access_token,
});

const mapDispatchToProps = (dispatch) => ({
  accesstoken: (access_token) =>
    dispatch({ type: LOGIN, payload: { access_token } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWrapper);